import { render } from "./inquiryList.vue?vue&type=template&id=62ab0e57&scoped=true&ts=true"
import script from "./inquiryList.vue?vue&type=script&lang=ts&config=true"
export * from "./inquiryList.vue?vue&type=script&lang=ts&config=true"

import "./inquiryList.vue?vue&type=style&index=0&id=62ab0e57&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ab0e57"]])

export default __exports__